



import React, { useState, useEffect } from 'react';

// Helper function to ensure URLs from the database are relative, fixing mixed content issues.
const makeUrlRelative = (url: string | null): string | null => {
    if (!url || !url.startsWith('http')) {
        return url; // It's already relative, a data URL, or empty
    }
    try {
        const urlObject = new URL(url);
        return urlObject.pathname; // Returns "/uploads/logo.png"
    } catch (error) {
        // If it fails to parse, it might be a malformed URL. Return it as is.
        return url;
    }
};

export const Logo: React.FC<{ className?: string; companyName?: string; isSidebarOpen?: boolean }> = ({ className, companyName, isSidebarOpen }) => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);

  useEffect(() => {
    try {
        const fullLogo = makeUrlRelative(localStorage.getItem('lam-custos-logo-full'));
        const iconLogo = makeUrlRelative(localStorage.getItem('lam-custos-logo-icon'));

        if (isSidebarOpen) {
          setLogoUrl(fullLogo);
        } else {
          setLogoUrl(iconLogo || fullLogo); // Fallback to full logo if icon isn't set
        }
    } catch (error) {
        console.error("Failed to get logos from localStorage.", error);
        setLogoUrl(null); // Ensure fallback to default SVG
    }
  }, [isSidebarOpen]);

  const tealColor = "#006781";
  const limeColor = "#7EC400";
  const whiteColor = "#FFFFFF";

  return (
    <div className={`flex items-center h-full ${isSidebarOpen ? 'space-x-2 px-3' : 'justify-center'} py-3 ${className}`}>
      {logoUrl ? (
        <img 
          src={logoUrl} 
          alt="System Logo" 
          className={`object-contain ${isSidebarOpen ? 'max-h-10' : 'max-h-8'}`}
        />
      ) : (
        <svg
          width={isSidebarOpen ? "40" : "32"}
          height={isSidebarOpen ? "24" : "20"}
          viewBox="0 0 100 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-label="Lam Custos Logo"
          className="flex-shrink-0"
        >
          <polygon points="0,60 30,0 42,20 18,60" fill={tealColor} />
          <polygon points="38,0 62,0 50,25" fill={tealColor} />
          <polygon points="58,22 70,0 100,60 80,60" fill={limeColor} />
          <polygon points="30,0 38,0 44,15 42,20" fill={whiteColor} />
          <polygon points="62,0 70,0 60,18 58,22" fill={whiteColor} />
          <polygon points="42,20 50,25 58,22 50,28" fill={whiteColor} />
        </svg>
      )}
      {companyName && isSidebarOpen && <span className="font-semibold text-xl text-white whitespace-nowrap">{companyName}</span>}
    </div>
  );
};